var DEFAULT_CARET_MARGIN = 2;
// Get a scrollTop value to make the cursor visible
export default function getScrollTopForCursor(dockingViewState, scrollContainerScrollTop, containerTop, containerBottom, cursorTop, cursorBottom, caretMargin) {
    if (caretMargin === void 0) { caretMargin = DEFAULT_CARET_MARGIN; }
    var topOverflow = containerTop + dockingViewState.topDockingHeight + caretMargin - cursorTop;
    var bottomOverflow = cursorBottom -
        (containerBottom -
            dockingViewState.bottomDockingHeight -
            dockingViewState.scrollBarHeight) +
        caretMargin;
    // Scroll cursor into view if needed
    if (dockingViewState.isTopDocking && topOverflow > 0) {
        scrollContainerScrollTop -= topOverflow;
    }
    else if (dockingViewState.isBottomDocking && bottomOverflow > 0) {
        scrollContainerScrollTop += bottomOverflow;
    }
    return scrollContainerScrollTop;
}
//# sourceMappingURL=getScrollTopForCursor.js.map